<template>
  <el-dialog
    :visible.sync="isShowConvertPpsToGh"
    class="wallet-dialog large"
    :close-on-click-modal="false"
    @open="onOpen"
    @close="onClose"
  >
    <template v-slot:title>
      <div class="el-dialog__title">
        <img src="/assets/images/icons/convert-icon.png" alt="Convert Icon">
        <span>Convert PPST To Gh/s with package {{currentConvertItem.amountUsd}} USD</span>
      </div>
    </template>
    <div class="popup-inner" :class="{ 'loading': isProcessing }">
      <template v-if="currentConvertItem.packageId">
        <template v-if="currentConvertItem.remainingPercent === 0">
          <el-tag size="tini" effect="dark" style="margin-bottom: 20px;">
            <i class="el-icon-circle-check" style="font-size: 16px; font-weight: 500;"></i>
            You have converted 100% of PPST amount to Gh/s with the package {{currentConvertItem.amountUsd}} USD
          </el-tag>
        </template>
        <div class="item-converts flex-box">
          <div class="item-convert flex-1">
            <div class="item-image">
              <img src="/assets/images/icons/ppst.png" alt="PPST">
            </div>
            <div class="item-entry">
              <h3>Total Convert</h3>
              <span>{{currentConvertItem.totalConvert}} PPST</span>
            </div>
          </div>
          <div class="item-convert flex-1">
            <div class="item-image">
              <img src="/assets/images/icons/ppst.png" alt="" style="width: 50px">
            </div>
            <div class="item-entry">
              <h3>Remaining</h3>
              <span>{{currentConvertItem.totalRemaining}} PPST (~ {{currentConvertItem.remainingPercent}}%)</span>
            </div>
          </div>
          <div class="item-convert flex-1">
            <div class="item-image">
              <img src="/assets/images/icons/gh.png" alt="Gh">
            </div>
            <div class="item-entry">
              <h3>Converted</h3>
              <span>{{currentConvertItem.totalConverted}} PPST to {{totalGhConverted}} Gh/s</span>
            </div>
          </div>
        </div>
        <template v-if="currentConvertItem.percentConvert && currentConvertItem.remainingPercent > 0">
          <label>Choose percent convert</label>
          <div class="item-convert item-box-convert">
            <template v-for="(convert, percent) in currentConvertItem.percentConvert" >
              <div
                class="box-percent"
                :key="percent"
                :class="{'disable': convert > currentConvertItem.totalRemaining}"
                @click="convertPps(percent)"
              ><span>Convert {{percent}}% PPST to Gh/s</span><strong>{{convert}} PPST</strong></div>
            </template>
          </div>
        </template>
        <div class="item table-box">
          <label>History</label>
          <div class="table-fixed-wrap table-history-convert">
            <div class="table-box-inner">
              <dl class="table-small">
                <dt>
                  <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                  <div class="flex-1">PPST</div>
                  <div class="flex-1">Gh/s</div>
                  <div class="flex-1">Percent (%)</div>
                  <div class="flex-2">Date</div>
                </dt>
                <dd v-for="(item, index) in convertHistory" :key="index">
                  <div class="item-no">{{ index + 1 }}</div>
                  <div class="flex-1">{{ item.amountPpst }}</div>
                  <div class="flex-1">{{ item.amountBeauty }}</div>
                  <div class="flex-1">{{ item.percent }}%</div>
                  <div class="flex-2">{{item.beautyCreatedAt}}</div>
                </dd>
                <dd v-if="!convertHistory.length" class="no-data-wrap">
                  <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  data () {
    return {
      isProcessing: false,
      form: {
        amount: ''
      }
    }
  },
  computed: {
    isShowConvertPpsToGh: {
      get () {
        return this.$store.getters.isShowConvertPpsToGh
      },
      set () {
        this.$store.dispatch('toggleConvertPpsToGh')
      }
    },
    currentConvertItem () {
      return this.$store.getters.currentConvertItem
    },
    convertHistory () {
      return this.$store.getters.convertHistory
    },
    totalGhConverted () {
      let total = 0
      this.convertHistory.forEach((item) => {
        total += item.amount
      })
      total = new BigNumber(total).toFixed(2)
      return total
    }
  },
  methods: {
    onOpen () {
      this.getHistory()
    },
    getHistory () {
      this.isProcessing = true
      this.$store.dispatch('getConvertHistory', {
        packageId: this.currentConvertItem.packageId
      }).then(() => {
        this.isProcessing = false
      })
    },
    onClose () {
      this.$store.dispatch('setConvertHistory', [])
    },
    convertPps (percent) {
      if (parseInt(percent) > this.currentConvertItem.remainingPercent) {
        console.log(parseInt(percent))
        console.log(this.currentConvertItem.remainingPercent)
        return
      }
      if (percent) {
        this.$confirm('Do you want to convert your PPTS to Gh/s?', 'Confirm', {
          confirmButtonText: 'Yes',
          dangerouslyUseHTMLString: true,
          iconClass: 'no-icon',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.isProcessing = true
          this.$store.dispatch('convertToGh', {
            packageId: this.currentConvertItem.packageId,
            percent: parseInt(percent)
          }).then(rs => {
            this.currentConvertItem.percentConverted = rs
            this.$store.dispatch('setCurrentConvertItem', this.currentConvertItem)
            this.isProcessing = false
            this.getHistory()
          })
        }).catch(() => {
        })
      }
    }
  }
}
</script>
